import React from "react";
import DashboardSideMenu from "./DashboardSideMenu";

const Dashboard = () => {
  return (
    <>
      <div className="overflow-auto ">
        <div>
          <DashboardSideMenu />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
